import type { Lesson, Unit } from "./types";

export function nextStageInLesson(unit: Unit, currentStageId: string): Lesson | undefined {
  const index = unit.lessons.findIndex((stage) => stage.id === currentStageId);
  return index >= 0 ? unit.lessons[index + 1] : undefined;
}

export function firstStageOfNextLesson(units: Unit[], currentUnitId: string): Lesson | undefined {
  const index = units.findIndex((unit) => unit.id === currentUnitId);
  return index >= 0 ? units[index + 1]?.lessons[0] : undefined;
}
